import { UUID } from '@/plugins/common'
import _ from 'lodash'
export default class DefaultAttr {
  _ = null
  constructor (args = {}) {
    const defaults = {
      id: UUID.create(),
      width: args.width || 0,
      height: 320,
      position: args.position || {},
      ratio: args.ratio || 0.5,
      type: args.type || '',
      reportType: 5,
      zIndex: 66,
      headTitle: {
        show: false,
        value: ''
      }
    }
    // 因为需要适配，所以需要记录修改之前的宽高和位置
    args.oldInfo = {
      position: _.clone(args.position),
      width: args.width,
      height: args.height
    }
    _.defaults(this, args, defaults)
    this._ = _
  }
  /**
   * 0、装饰透明度
   * 1、背景和边框
   * 2、文本字体
   * 3、标题
   * 4、正文字体
   * 5、行表头字体
   * 6、行表头背景
   * 7、行内分割线
   * 8、备注字体
   * 9、数字字体
   * 10、图表字体
   * 11、表内分割线
   * 12、柱形颜色
   * */
  getStyleSetting (type, needStyleList = false) {
    let styleList = []
    switch (type) {
      case 'report':
        styleList = ['1', '3', '4', '5', '6', '7']
        break
      case 'diagram':
        // 默认加载所有需要的值，因为构建数据模型的时候不加载这个会导致数据不能双向绑定
        styleList = ['1', '3', '8', '9', '10', '11', '12']
        break
      case 'rich-text-box':
        styleList = ['1', '3', '10', '11']
        break
      case 'text-control':
        styleList = ['1', '2']
        break
      case 'url-page':
        return {}
      case 'calendar':
        return {}
      case 'clock':
        styleList = ['1', '2']
        break
      case 'decorate':
        // 装饰只有一个透明度
        styleList = ['0', '1']
        break
      default:
        throw new Error('未知类型')
    }
    let style = {}
    let styleAttr = DefaultAttr.getStyleAttr()
    styleList.forEach(item => {
      style = _.assign(style, styleAttr[item])
    })
    return needStyleList ? {style, styleList} : style
  }
  setStyleSetting (type, children) {
    let styleObj = this.getStyleSetting(type, true)
    // 编辑的情况下就用本身的不需要merge
    _.mergeWith(children, styleObj.style, (childrenValue, defaultValue) => childrenValue || defaultValue)
    // 手动挂载一下 styleList 方便使用，只有新建的时候需要挂载
    if (!children.styleList) {
      children.styleList = styleObj.styleList
    }
  }
  getStyleWithStyleList (styleList) {
    let style = {}
    let styleAttr = DefaultAttr.getStyleAttr()
    styleList.forEach(item => {
      style = _.assign(style, styleAttr[item])
    })
    return style
  }
  static getStyleAttr () {
    // 字体样式是统一的结构
    let font = {
      font: {
        // 字体颜色
        color: '',
        // 大小
        size: '',
        // 字体类型
        family: ''
      },
      // 字体样式：斜体之类的
      fontStyle: ''
    }
    let border = {
      width: '',
      style: '',
      color: ''
    }
    return {
      '0': {
        // 装饰透明度
        decorateOpacity: ''
      },
      '1': {
        // 背景和边框
        backgroundAndBorder: {
          // 背景颜色
          backgroundColor: '',
          // 透明度
          opacity: '',
          // 边框 1px solid #ccc
          border,
          // 边框样式，选择背景图的。。。。。
          borderStyle: ''
        }
      },
      '2': {
        // 文本字体
        textFont: font
      },
      '3': {
        // 标题
        titleFont: font
      },
      '4': {
        // 正文字体
        textStyle: font
      },
      '5': {
        // 行表头字体
        headerFont: font
      },
      '6': {
        // 行表头背景
        headerBackground: {
          // 背景颜色
          backgroundColor: '',
          // 透明度
          opacity: ''
        }
      },
      '7': {
        // 行内分割线
        LineDivider: border
      },
      '8': {
        // 备注字体
        remakeFont: font
      },
      '9': {
        // 数字字体
        numberFont: font
      },
      '10': {
        // 图表字体
        chartFont: font
      },
      '11': {
        // 表内分割线
        tableDivider: border
      },
      '12': {
        columnColor: {
          color: '',
          colorList: []
        }
      }
    }
  }
  /**
   * 修改当前控件的位置信息
   * @param {Number} parentWidth 父容器的属性
   * @param {Object} designStyle 上一次设计的时候的宽高
   * @param resizeTH 是否修改top和高度
   * */
  updateHeightOrWidth (parentWidth, designStyle, resizeTH) {
    const ratio = designStyle.width === 1 ? 1 : parentWidth / designStyle.width
    this.position.left = this.oldInfo.position.left * ratio
    this.width = this.oldInfo.width * ratio
    if (resizeTH) {
      this.position.top = this.oldInfo.position.top * ratio
      this.height = this.oldInfo.height * ratio
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/report/design/customPage/assets/js/default.js